<template>
<div class="nkn-get-started">
  <div class="common-sub-title">{{$t("miner.started.title")}}</div>
  <div class="mining-guide">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12">
        <div class="mining-guide-en">
          <ul>
            <li class="common-fourth-link"><a :href="$url.MINING_INTRO.en" target="_blank">{{$t("miner.started.subtitle1")}}</a></li>
            <li class="common-fourth-link"><a :href="$url.MINING_INTRO.zh" target="_blank">{{$t("miner.started.subtitle2")}}</a></li>
            <li class="common-fourth-link"><a :href="$url.MINING_INTRO.other" target="_blank">{{$t("miner.started.subtitle3")}}</a></li>
            <!--<li class="common-fourth-link">
              <a :href="$url.MINING_INTRO.guide" target="_blank">{{$t("miner.started.sub1li1")}}</a>
            </li>
            <li class="common-fourth-link">
              <a :href="$url.MINING_INTRO.setupOnDO" target="_blank">{{$t("miner.started.sub1li2")}}</a>
            </li>
            <li class="common-fourth-link">
              <a :href="$url.MINING_INTRO.setupOnWindows" target="_blank">{{$t("miner.started.sub1li3")}}</a>
            </li>
            <li class="common-fourth-link">
              <a :href="$url.MINING_INTRO.makeNKM" target="_blank">{{$t("miner.started.sub1li4")}}</a>
            </li>
            <li class="common-fourth-link">
              <a :href="$url.MINING_INTRO.setScripts" target="_blank">{{$t("miner.started.sub1li5")}}</a>
            </li>-->
          </ul>
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters({
      lang: 'getLang'
    })
  }
}
</script>

<style lang="scss" scoped>
.nkn-get-started {
  @include common-inner();

  .mining-guide {
    padding: 1rem 0 1.5rem 0;

    &-en,
    &-other {
      @include nkn-font-set(.9rem, currentColor);
    }

    .common-fourth-link {
      line-height: 1.2;
      margin: 10px 0;
    }

    a {
      display: inline-block;

      &:hover {
        color: #51B2FF !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/miner/nknGetStarted.vue